export default __webpack_public_path__ + "static/media/BE_Sciences_RGB_Horizontal_Reverse-Color.72c69186.svg";